import { List, Record } from 'immutable';
import { FREE_BETS_FAILURE, FREE_BETS_REQUEST, FREE_BETS_SUCCESS } from './actions';

export const VOUCHER_STATUS_ACTIVE = 'ACTIVE';
export const VOUCHER_STATUS_REDEEMED = 'REDEEMED';
export const VOUCHER_STATUS_EXPIRED = 'EXPIRED';
export const VOUCHER_STATUS_CANCELLED = 'CANCELLED';

export const InitialState = new Record({
  vouchers: new List(),
  isLoadingFreeBets: false
});

export const Voucher = new Record({
  barcode: '',
  expiryDate: '',
  status: '',
  value: ''
});

export default (state = new InitialState(), action) => {
  switch (action.type) {
    case FREE_BETS_REQUEST: {
      return state.set('isLoadingFreeBets', true);
    }
    case FREE_BETS_SUCCESS: {
      return state
        .set('vouchers', new List(action.vouchers.map(v => new Voucher(v))))
        .set('isLoadingFreeBets', false);
    }
    case FREE_BETS_FAILURE: {
      return state.set('isLoadingFreeBets', false);
    }
    default:
      return state;
  }
};
